export const VERTICAL_OPTIONS = [
  { value: 'assistenciaTecnica', labelKey: 'verticals.assistenciaTecnica' },
  { value: 'clinicas', labelKey: 'verticals.clinicas' },
  { value: 'marketingAgencias', labelKey: 'verticals.marketingAgencias' },
  { value: 'imobiliarias', labelKey: 'verticals.imobiliarias' },
  { value: 'logistica', labelKey: 'verticals.logistica' },
  { value: 'operacaoComercial', labelKey: 'verticals.operacaoComercial' },
  { value: 'generic', labelKey: 'verticals.generic' },
] as const;

export type Vertical = (typeof VERTICAL_OPTIONS)[number]['value'];

export type VerticalOption = (typeof VERTICAL_OPTIONS)[number];

/**
 * Mapa do enum int do backend (ASP.NET Core serializa enum como int por padrão)
 * para a chave string usada no frontend. Espelho de `Vertical.cs` no backend.
 */
export const VERTICAL_INT_TO_KEY: Record<number, Vertical> = {
  0: 'generic',
  1: 'assistenciaTecnica',
  2: 'clinicas',
  3: 'marketingAgencias',
  4: 'imobiliarias',
  5: 'logistica',
  6: 'operacaoComercial',
};

const VALID_VERTICAL_KEYS = new Set<string>(VERTICAL_OPTIONS.map((opt) => opt.value));

/**
 * Normaliza valor de vertical vindo de qualquer DTO do backend.
 * Aceita número (enum int do ASP.NET) ou string (chave do enum).
 * Retorna `null` quando ausente, vazio ou desconhecido.
 */
export function normalizeVerticalValue(raw: unknown): Vertical | null {
  if (raw === null || raw === undefined) return null;
  if (typeof raw === 'number' && Number.isInteger(raw)) {
    return VERTICAL_INT_TO_KEY[raw] ?? null;
  }
  if (typeof raw !== 'string') return null;
  const trimmed = raw.trim();
  if (!trimmed) return null;
  return VALID_VERTICAL_KEYS.has(trimmed) ? (trimmed as Vertical) : null;
}
